<template>
  <section id="update_profile_picture">
    <section id="profile_picture__cropper">
      <vue-cropper
        v-show="imgSrc"
        alt="Source Image"
        ref="cropper"
        :src="imgSrc"
        :aspect-ratio="1"
        :crop-box-resizable="true"
        :min-crop-box-width="24"
        :min-crop-box-height="24"
        :view-mode="2"
        :drag-mode="'move'"
      />
    </section>
    <section
      class="profile_picture__controls"
      v-if="imgSrc"
    >
      <button
        class="btn__icon"
        role="button"
        :title="$t('image.ROTATE', { num: '90' })"
        @click.prevent="rotate(90)"
      >
        <Icon name="rotate" />
      </button>
      <button
        class="btn__icon"
        role="button"
        :title="$t('image.ZOOM_IN')"
        @click.prevent="zoom(0.1)"
      >
        <Icon name="zoom_in" />
      </button>
      <button
        class="btn__icon"
        role="button"
        :title="$t('image.ZOOM_OUT')"
        @click.prevent="zoom(-0.1)"
      >
        <Icon name="zoom_out" />
      </button>
    </section>
    <section class="profile_picture__controls">
      <input
        id="input__image"
        ref="input"
        type="file"
        name="input__image"
        accept="image/*"
        @change="setImage"
      >
    </section>
    <section class="profile_picture__actions">
      <SpinnerButton
        :is-disabled="!imgSrc"
        :button-id="'btn__save_image'"
        :button-class="'btn__confirm'"
        :button-type="'submit'"
        :button-listener="onClickUploadImage"
        :button-text="$t('buttons.SAVE')"
      />
    </section>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import VueCropper from "vue-cropperjs";
import axios from "axios";
import { getToken, getHeader } from "../../helpers/functions";
import Icon from "../global/Icon.vue";
import SpinnerButton from "../global/SpinnerButton";

const header = getHeader(getToken("ifragasatt_cookie"));

export default {
  name: "UpdateProfilePicture",
  components: {
    Icon,
    VueCropper,
    SpinnerButton,
  },
  data() {
    return {
      imgSrc: null,
    };
  },
  props: {
    isAlias: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(["myProfile", "myAlias"]),
  },
  methods: {
    ...mapActions([
      "setIsLoading",
      "showToast",
      "updateProfile",
      "updateAlias",
    ]),
    rotate(deg) {
      this.$refs.cropper.rotate(deg);
    },
    zoom(percent) {
      this.$refs.cropper.relativeZoom(percent);
    },
    onClickUploadImage() {
      this.setIsLoading(true);

      this.$refs.cropper
        .getCroppedCanvas({
          width: 256,
          height: 256,
          imageSmoothingEnabled: true,
          imageSmoothingQuality: "high"
        })
        .toBlob((blob) => {
            const file = new File([blob], "image.jpeg", {
            type: blob.type,
            });

            const splitStr = file.type.split("/");
            const fileType = splitStr[splitStr.length - 1];

          this.getPresignedUrl(fileType).then((data) => {
              axios
                .put(data.url, file, {
                  headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                  },
                })
              .then((res) => {
                if (res.status == 200) {
                  const imageUrl = `${process.env.VUE_APP_IMAGE_BUCKET}/${data.fileName}`;
                  this.setNewProfileInfo(imageUrl);
                }
              })
              .catch((err) => {
                  console.error(err);
                  this.showToast({
                    message: "errors.UPLOAD_FAILED",
                  type: "error",
                  });
                })
                .finally(() => {
                  this.setIsLoading(false);
                });
            });
        }, "image/jpeg", 0.90);
    },
    getPresignedUrl(type) {
      const url = `${process.env.VUE_APP_FILE_UPLOADER}/?fileType=${type}`;

      return axios
        .get(url, header)
        .then((res) => {
          return res.data;
        })
        .catch((err) => {
          console.error(err);
          this.showToast({
            message: "errors.UPLOAD_FAILED",
            type: "error",
          });
        });
    },
    // Sets new image in preview window
    setImage(e) {
      const file = e.target.files[0];
      if (!file || file.type.indexOf("image/") === -1) {
        return;
      }

      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.imgSrc = event.target.result;
          this.$refs.cropper.replace(event.target.result);
        };
        reader.readAsDataURL(file);
      } else {
        alert("Sorry, FileReader API not supported");
      }
    },
    setNewProfileInfo(url) {
      const payload = {
        id: 0,
        description: "",
        profilePicture: url,
        imageRotation: 0,
      };

      if (this.isAlias) {
        payload.id = this.myAlias.id;
        payload.description = this.myAlias.description;
        this.updateAlias(payload);
      } else {
        payload.id = this.myProfile.userId;
        payload.description = this.myProfile.description;
        this.updateProfile(payload);
      }
    },
  },
  watch: {
    imgSrc(newVal, oldVal) {
      if (!newVal) this.imgSrc = oldVal;
    },
  },
};
</script>
